import axios from 'axios';
import CONFIG from '../config/config';

export interface MaintenanceStatus {
  enabled: boolean;
  content: string;
}

export const MaintenanceAPI = {
  get: async (): Promise<MaintenanceStatus> => {
    const response = await axios.get<MaintenanceStatus>(
      `${CONFIG.API_ENDPOINT}/v1/public/maintenance`,
      { timeout: 8000 }
    );
    return response.data;
  },
};
